var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"form-label"},[_vm._t("default"),_vm._v(" "),(!_vm.required)?_c('span',{staticClass:"bg-main-color px-4 py-0.5 text-white rounded-full text-sm ml-2 break-keep"},[_vm._v("任意")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }